<template>
  <div class="page page-drivers">
    <h1 class="h2">Изменить документ</h1>
    <component
      v-if="currentComponent"
      :is="currentComponent"
      :documentData="document.data"
      @update="handleData"
    />
    <button class="btn btn-primary" @click="updateDocument()">Записать</button>
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Swal from 'sweetalert2'
import Types from '@/views/driverDocuments/types'
import DocumentsAPI from '@/api/driver-documents'

export default {
  name: 'UpdateDocument',
  props: ['driverId', 'documentId'],
  data () {
    return {
      isUpdating: false,
      currentComponent: null,
      document: {
        id: this.documentId,
        type: '',
        data: '',
        driver_id: ''
      }
    }
  },
  mounted () {
    DocumentsAPI.getItem({ id: this.documentId }).then(response => {
      this.document = response
      this.currentComponent = Types[this.document.type].editComponent
    })
  },
  methods: {
    handleData ({ type, data }) {
      this.document.type = type
      this.document.data = data
    },
    updateDocument () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      DocumentsAPI.updateItem(this.document)
        .then(document => {
          this.isUpdating = false
          this.$router.push(`/drivers/${this.driverId}`)
          return document
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>
